import { render, staticRenderFns } from "./DeliveryTotalCourier.vue?vue&type=template&id=2735da94&"
import script from "./DeliveryTotalCourier.vue?vue&type=script&lang=js&"
export * from "./DeliveryTotalCourier.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTotalCourier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports